module.exports = __webpack_public_path__ + "ec22f3d71682dafa5aaee71eee75807b.svg";